<template>
<!--   <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
   <b-link class="navbar-brand" to="#"></b-link>
    <span class="font-weight-normal ml-4 mt-1 h4">Team HACK'D</span>
    <button class="navbar-toggler sidebar-toggler d-md-down-none mr-auto" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <a id="home-link" class="ml-3" href="/">Home</a>
    <router-link class="ml-3 pr-4" :to="'story'">Story</router-link>
     <router-link class="ml-3" :to="'model'">Model</router-link> -->
    <!-- <router-link class="ml-3 pr-4" :to="'data'">Data</router-link> -->
  <!-- </header>  -->

    <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <span class="font-weight-normal ml-4 mt-1 h4">Team HACK'D</span>
    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-navbar-nav class="">
 
    <!-- <a id="home-link nav-link" class="px-3" href="/">Home</a> -->
    <router-link class="px-3 nav-link" :to="'/'">Home</router-link>
    <router-link class="px-3 nav-link" :to="'story'">Story</router-link>
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto">
    </b-navbar-nav>
  </header>
</template>
<script>
export default {
  name: 'c-header',
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue